import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";
import { baixarGet } from "../../lib/download";
import type { Descritivo, ResumoDescritivo } from "../../types/descritivos";

const BASE = "/portal-cliente/descritivos";

/** Convenção da própria função no banco: -1 significa todos os projetos. */
export const TODOS_OS_PROJETOS = -1;

export interface FiltrosDescritivo {
  inicio: string;
  fim: string;
  projetoId: number;
}

export const useDescritivo = (filtros: FiltrosDescritivo) =>
  useQuery({
    queryKey: ["descritivo", filtros],
    queryFn: async (): Promise<Descritivo> => {
      const { data } = await api.get<Descritivo>(BASE, { params: filtros });
      return data;
    },
    enabled: Boolean(filtros.inicio && filtros.fim),
  });

export const useProjetosDescritivo = () =>
  useQuery({
    queryKey: ["descritivo-projetos"],
    queryFn: async (): Promise<{ id: number; nome: string | null }[]> => {
      const { data } = await api.get<{ id: number; nome: string | null }[]>(
        `${BASE}/projetos`
      );
      return data;
    },
    staleTime: 10 * 60 * 1000,
  });

export const useResumoDescritivo = () =>
  useQuery({
    queryKey: ["descritivo-resumo"],
    queryFn: async (): Promise<ResumoDescritivo> => {
      const { data } = await api.get<ResumoDescritivo>(`${BASE}/resumo`);
      return data;
    },
    staleTime: 5 * 60 * 1000,
  });

export const exportarDescritivo = (
  filtros: FiltrosDescritivo,
  formato: "pdf" | "excel"
): Promise<void> =>
  baixarGet(
    `${BASE}/relatorio`,
    { ...filtros, formato },
    `descritivo-${filtros.inicio}-a-${filtros.fim}.${formato === "excel" ? "xlsx" : "pdf"}`
  );
